// websocketService.js
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";

const baseUrl = process.env.REACT_APP_API_PATH;

let stompClient = null;

export const connectWebSocket = (role, userId, onNotification, onUnreadCount) => {
    // Ensure correct protocol (http -> https if page is https)
    let wsUrl = `${baseUrl}/ws`;
    if (window.location.protocol === "https:" && wsUrl.startsWith("http:")) {
        wsUrl = wsUrl.replace("http:", "https:");
    }

    const socket = new SockJS(wsUrl);

    stompClient = new Client({
        webSocketFactory: () => socket,
        reconnectDelay: 5000,
        // debug: (str) => console.log("[STOMP]", str),
        onConnect: () => {
            // console.log("✅ Connected to WebSocket");
            // Subscribe for new notifications
            stompClient.subscribe(`/topic/notification/${role}/${userId}`, (message) => {
                try {
                    const notification = JSON.parse(message.body);
                    onNotification(notification);
                } catch (e) {
                    console.error("Invalid notification payload:", message.body);
                }
            });
            // Subscribe for unread count
            stompClient.subscribe(`/topic/unread/${role}/${userId}`, (message) => {
                try {
                    const count = JSON.parse(message.body); // backend might send just a number
                    onUnreadCount(count);
                } catch (e) {
                    console.error("Invalid unread payload:", message.body);
                    onUnreadCount(Number(message.body) || 0);
                }
            });
        },
        onStompError: (frame) => {
            console.error("❌ Broker error: " + frame.headers["message"]);
        },
    });

    stompClient.activate();
};

export const disconnectWebSocket = () => {
    if (stompClient) {
        stompClient.deactivate();
        stompClient = null;
    }
};
